import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;

@Component({
  selector: 'g10-route-holiday-config',
  templateUrl: './route-holiday-config.component.html',
  styleUrls: ['./route-holiday-config.component.css']
})
export class RouteHolidayConfigComponent implements OnInit {

 
  public orgID: any;
  public holidayConfigData: any;

  public filterTable: boolean = true;
  public tableShow: boolean = true;//false;
  public cols = [
    { key: '#', display: '#', minWidth : '50px' },
    { key: 'name', display: 'Route Name',
      config: {
        isTruncate: true,
        truncateData:{
          limit:100,
          concatVal:'...',
        }
      }
    },
    { key: 'holiday', display: 'Holiday',
      config: {
        isTruncate: true,
        truncateData:{
          limit:100,
          concatVal:'...',
        }
      }
    },
    {
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'view', color: 'primary', icon: 'View' },
          { display: 'Delete', color: 'warn', icon: 'Delete',checkKey:true },
        ]
      }
    }
  ];
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  }


  /* filters */
  searchChangeObserver: any;
  public searchInputValue = '';

  /* Route cut off Form */
  public closeHolidayFormPopup: boolean = true;
  public formPopup: boolean = true;
  public routeData: any = [];

  /* Route cut off View */
  public closeHolidayViewPopup: boolean = true;
  public selectedHolidayData:any = {};

  constructor(
    public api: ApiService,
    public router: Router,
    public storage: StorageService,
    public swal: SweetAlert,
    public route: ActivatedRoute,
    public loader: LoaderService,
    public comService: CommonServices,
  ) {
    this.route.paramMap.subscribe(params => {
      this.orgID = params.get('orgID');
    });
  }

  ngOnInit() {
    // this.getHolidayConfigData();
  }

  getHolidayConfigData(page = 1, limit = 10, search?) {
    const obj = {
      // page: page,
      // limit: limit,
    };
    if (search) obj['routeName'] = search;
    this.api.transportManagerRouteHolidayList(obj).then((res: any) => {
      this.processTableData(res.data);
      this.processPagination(res, obj);
      if (res.status == 'success') {
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  processPagination(data, req) {
    this.tableShow = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.tableShow = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    this.getHolidayConfigData(data.page, data.limit, this.searchInputValue);
  }

  onSearchChange(searchValue: string) {

    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.searchInputValue = term;
          if (String(term).length == 0) this.getHolidayConfigData(1, this.paginationData.limit, term);
          else if (String(term).length >= 2) this.getHolidayConfigData(1, this.paginationData.limit, term);

        });
    }

    this.searchChangeObserver.next(searchValue);
  }

  processTableData(data) {
    this.tableShow = false;
    this.holidayConfigData = data.map((route) => {
      let obj = {
        name: route.routeName,
        holiday: route.holiday,
        uniqID: route.uniqID,
      }
      return obj;
    });
    setTimeout(() => { this.tableShow = true; }, 100);
  }

  onActionHandler(e: any) {
   if (e.action.display.toLowerCase() == 'view') {
      console.log(e);
      this.loadViewModal(e.data);

    }
  }

  loadViewModal(data){
    this.selectedHolidayData = data;
    this.closeHolidayViewPopup = false;
  }

  formModalPopup() {
    this.closeHolidayFormPopup = false;
  }

  submitRouteHoliday(obj) {
    /* api calls */
    console.log(obj);
    this.api.transportManagerRouteHolidayUpdate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getHolidayConfigData(1,5,this.searchInputValue);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });

  }

}
